import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.75 4c.966 0 1.75.784 1.75 1.75v11a1.75 1.75 0 0 1-1.75 1.75h-6.736l-4.389 3.51A1 1 0 0 1 7 21.23V18.5H3.75A1.75 1.75 0 0 1 2 16.75v-11C2 4.784 2.784 4 3.75 4zm-16 1.5a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h4a.75.75 0 0 1 .75.75v2.44l3.781-3.026a.74.74 0 0 1 .469-.162V17h7a.25.25 0 0 0 .25-.25v-11a.25.25 0 0 0-.25-.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }